import { CheckoutState } from 'pages/checkout/connect/types';

import { Clinic } from 'types/Clinic';

export enum StepId {
  ACCOUNT = 'account',
  PHONE_NUMBER = 'phone-number',
  ONGOING_CARE = 'ongoing-care',
  TREATMENTS = 'treatments',
  PATIENT_INFO = 'patient-info',
  INSURANCE = 'insurance',
  VERIFY = 'verify',
  CONFIRM = 'confirm',
}

export interface CheckoutStepParams {
  checkoutState: CheckoutState;
  isUserAuthenticated: boolean;
  isMemberIdOptional: boolean;
  patient?: any;
  match: any;
  clinic: Clinic;
  checkoutOngoingCareAnswer: string | null;
  checkoutSelectedTreatments: string[] | null;
}

/*
  Note: the component to render is not included in the stepDefinition to avoid circular dependencies
  If you add a step, you must also add it to the stepComponents object in app/pages/checkout/steps/stepComponents.ts
*/
export interface CheckoutStepDefinition {

  /**
   * The unique identifier for the step
   */
  id: StepId;

  /**
   * Whether to show the step in the progress bar
   */
  showInProgress: boolean;

  /**
   * The display name for the step in the progress bar
   */
  name: string;

  /**
   * The URL path for the step (E.g. /checkout/:path)
   */
  path: string;

  /**
   * The Redux key for the step completion status (E.g. checkoutData.stepCompletion[reduxKey].status)
   */
  reduxKey?: string;

  /**
   * Check whether the user has completed the step based on the checkout state
   * This is used to send the user back to the first incomplete step
   *
   * TODO type the patient object
   */
  isComplete: (params: CheckoutStepParams) => boolean;

  /**
   * Whether the step is optional.
   * This is used for steps that should not be shown in certain cases.
   */
  isApplicable: (params: CheckoutStepParams) => boolean;
}
